export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20stage%20lighting%20casting%20dramatic%20shadows%2C%20empty%20velvet%20red%20seats%20in%20foreground%2C%20large%20projection%20screen%20with%20abstract%20warm%20glow%2C%20atmospheric%20haze%2C%20luxurious%20and%20mysterious%20mood%2C%20cinematic%20photography%20style%20with%20rich%20contrast%20and%20soft%20bokeh%20effects&width=1800&height=1000&seq=hero-cinema-main&orientation=landscape"
          alt="爱看影院 — 沉浸式观影体验"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs text-primary-300 font-medium">每日更新 · 海量高清资源</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 font-bold leading-tight mb-3">
              爱看影院 — 免费高清影视大全，追剧必备平台
            </h1>

            <p className="text-base md:text-lg text-primary-300 font-heading mb-6">
              电影 · 电视剧 · 综艺 · 动漫 — 一网打尽，流畅不卡顿
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl lg:max-w-none mb-8">
              爱看影院汇集全网热播免费电影与免费电视剧全集，覆盖动作、喜剧、爱情、科幻、悬疑、动漫等全类型影视资源。每日同步更新最新剧集，高清画质搭配智能加速引擎，确保观影流畅不缓冲。无论您是热衷追剧的剧迷，还是喜欢电影的影迷，这里都是您的免费在线观看首选地。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {[
                { icon: 'ri-database-2-line', text: '海量片库 · 10万+影视资源' },
                { icon: 'ri-refresh-line', text: '每日更新 · 同步热播剧集' },
                { icon: 'ri-speed-up-line', text: '高速播放 · 智能不缓冲' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <i className={`${item.icon} text-primary-400 text-base`}></i>
                  <span className="text-xs md:text-sm text-foreground-300 whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-950 font-semibold text-sm rounded-lg hover:bg-primary-400 transition-all cursor-pointer"
              >
                <i className="ri-play-circle-line text-base"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-300/30 text-foreground-200 font-medium text-sm rounded-lg hover:bg-foreground-50/5 transition-all cursor-pointer"
              >
                <i className="ri-trophy-line text-base"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="hidden lg:block flex-shrink-0 w-[420px] xl:w-[480px]">
            <div className="relative rounded-xl overflow-hidden aspect-[3/4] border border-background-700/40">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20geometric%20film%20strip%20elements%2C%20soft%20glowing%20orbs%2C%20theatrical%20spotlight%20effects%2C%20elegant%20and%20mysterious%20atmosphere%2C%20vintage%20cinema%20aesthetic%20mixed%20with%20modern%20minimalist%20design%2C%20deep%20shadows%20and%20rich%20warm%20accents&width=960&height=1280&seq=hero-poster-01&orientation=portrait"
                alt="爱看影院 — 热播影视推荐"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 rounded-full bg-background-950/70 backdrop-blur-sm text-xs text-primary-300 border border-primary-500/20">
                  今日推荐 · 热门精选
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}